import i18n from '@/plugins/i18n';
import {
  BYTES_TO_MB_CONVERSION_VALUE,
  MS_TO_SECONODS_CONVERSION_VALUEE,
} from '@/utils/templates/databaseTemplate/database.constants';
const metricsMONGOGraphs = () => ({
  lineCharts: [
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.asserts'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#f7507f', '#fdfcac', '#08856e', '#ffffff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName:
        'meter_mongodb_asserts_regular,meter_mongodb_asserts_warning,meter_mongodb_asserts_msg,meter_mongodb_asserts_user',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.countPerMinute'),
      },
      show: true,
      showForSingleSeries: true,
      showMetricDropdown: true,
      showmetricRate: true,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.backgroundFlushingFlushes'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#FDFCAC'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_mongodb_backgroundflushing_flushes',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.countPerMinute'),
      },
      showLegendForSeries: true,
      showmetricRate: true,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.backgroundFlushingTotal'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#FDFCAC'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_mongodb_backgroundflushing_total_ms',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.seconds'),
      },
      aggregation: '/',
      aggregationNum: MS_TO_SECONODS_CONVERSION_VALUEE,
      showLegendForSeries: true,
      showmetricRate: true,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.connection'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#f7507f', '#fdfcac'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName:
        'meter_mongodb_connections_available,meter_mongodb_connections_current',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.countPerMinute'),
      },
      showLegendForSeries: true,
      showMetricDropdown: true,
      showmetricRate: true,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.cursor'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#f7507f', '#fdfcac'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName:
        'meter_mongodb_cursor_total_open,meter_mongodb_cursor_timed_out',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.countPerMinute'),
      },
      showLegendForSeries: true,
      showMetricDropdown: true,
      showmetricRate: true,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.globalLock'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#f7507f', '#fdfcac'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName:
        'meter_mongodb_global_lock_active_clients,meter_mongodb_global_lock_current_queue',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.countPerMinute'),
      },
      showLegendForSeries: true,
      showMetricDropdown: true,
      showmetricRate: true,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.memory'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#f7507f', '#fdfcac', '#08856e'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName:
        'meter_mongodb_mem_mapped,meter_mongodb_mem_virtual,meter_mongodb_mem_resident',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.mbPerMinute'),
      },
      showLegendForSeries: true,
      showMetricDropdown: true,
      showmetricRate: true,
      aggregation: '/',
      aggregationNum: BYTES_TO_MB_CONVERSION_VALUE,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.network'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#f7507f', '#fdfcac', '#08856e'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_mongodb_net_num_request',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.countPerMinute'),
      },
      showLegendForSeries: true,
      showmetricRate: true,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.oplog'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#f7507f', '#fdfcac', '#08856e'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_mongodb_oplog_max_size,meter_mongodb_oplog_size',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.mbPerMinute'),
      },
      showLegendForSeries: true,
      showMetricDropdown: true,
      showmetricRate: true,
      aggregation: '/',
      aggregationNum: BYTES_TO_MB_CONVERSION_VALUE,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.opcounters'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: [
        '#f7507f',
        '#fdfcac',
        '#08856e',
        '#ffffff',
        '#aca4db',
        '#89d7d7',
      ],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName:
        'meter_mongodb_opcounter_command,meter_mongodb_opcounter_delete,meter_mongodb_opcounter_getmore,meter_mongodb_opcounter_insert,meter_mongodb_opcounter_query,meter_mongodb_opcounter_update',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.countPerMinute'),
      },
      showLegendForSeries: true,
      showMetricDropdown: true,
      showmetricRate: true,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.replicate'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: [
        '#f7507f',
        '#fdfcac',
        '#08856e',
        '#ffffff',
        '#aca4db',
        '#89d7d7',
      ],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName:
        'meter_mongodb_repl_command,meter_mongodb_repl_getmore,meter_mongodb_repl_delete,meter_mongodb_repl_insert,meter_mongodb_repl_query,meter_mongodb_repl_update',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.countPerMinute'),
      },
      showLegendForSeries: true,
      showMetricDropdown: true,
      showmetricRate: true,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.replicationMyState'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#fdfcac'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_mongodb_replication_mystate',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.countPerMinute'),
      },
      showLegendForSeries: true,
      showmetricRate: true,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.indexMissRatio'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#f7507f'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_mongodb_index_miss_ratio',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.ratioPerMinute'),
      },
      showLegendForSeries: true,
      showmetricRate: true,
    },
  ],
});

export default metricsMONGOGraphs;
